module.exports = __webpack_public_path__ + "static/img/touxiang.5714c31.png";